import React, { createContext, useContext, useState, useEffect } from 'react';
import authData from '../data/auth.json';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check for existing session on mount
    const savedUser = sessionStorage.getItem('vaultUser');
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (e) {
        sessionStorage.removeItem('vaultUser');
      }
    }
    setIsLoading(false);
  }, []);

  const login = (email, password) => {
    const foundUser = authData.users.find(
      (u) => u.email.toLowerCase() === email.toLowerCase() && u.password === password
    );

    if (foundUser) {
      // Don't store password in session
      const sessionUser = {
        id: foundUser.id,
        email: foundUser.email,
        name: foundUser.name,
        role: foundUser.role,
        shares: foundUser.shares,
        sharePercent: foundUser.sharePercent,
      };
      setUser(sessionUser);
      sessionStorage.setItem('vaultUser', JSON.stringify(sessionUser));
      return { success: true, user: sessionUser };
    }

    return { success: false, error: 'Invalid email or password' };
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem('vaultUser');
  };

  const value = {
    user,
    isLoading,
    isAuthenticated: !!user,
    login,
    logout,
    totalShares: authData.totalShares,
    treasury: authData.treasury,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
